import React, { useEffect, useRef, useState } from 'react'
import { ApiScoreCardPDF, ApiScoreCardPDF2 } from '../../apiService/Core/Apicall'
import { Box, Button, IconButton, Typography } from '@mui/material'
import { useLocation } from 'react-router-dom';
import PrintIcon from '@mui/icons-material/Print';
import CloudDownloadOutlinedIcon from '@mui/icons-material/CloudDownloadOutlined';
import { CancelOutlined } from '@mui/icons-material';
import storage from '../../utils/storage';




const ScorecardIcon: React.FC = () => {
    return (
        <svg
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_4569_9229)">
                <path
                    d="M36 30.364C36 33.4767 33.4767 36 30.364 36H5.63601C2.52331 36 0 33.4767 0 30.364V7.32681L7.32681 0H30.364C33.4767 0 36 2.52331 36 5.63601V30.364Z"
                    fill="#ADB792"
                />
                <path d="M0 11.2535V7.32715H3.90766L0 11.2535Z" fill="#C8A456" />
                <path
                    d="M0 7.32681H4.88459C6.22779 7.32681 7.32681 6.24653 7.32681 4.90333V0L0 7.32681Z"
                    fill="#BF613B"
                />
                <path
                    d="M6.03418 23.7917V12.0039H11.8687C12.4225 12.0039 12.9145 12.0945 13.3443 12.2753C13.7739 12.4563 14.1301 12.7078 14.4129 13.0301C14.6954 13.3523 14.9103 13.7368 15.0574 14.1834C15.2042 14.6302 15.2778 15.1247 15.2778 15.6675C15.2778 16.2102 15.2071 16.7191 15.0657 17.1939C14.9243 17.6688 14.7151 18.0788 14.4383 18.4236C14.161 18.7686 13.8079 19.04 13.3783 19.2377C12.9484 19.4358 12.4453 19.5345 11.8686 19.5345H7.9507V23.7918L6.03418 23.7917ZM7.95077 13.7678V17.7366H11.2073C11.9535 17.7366 12.499 17.57 12.844 17.2363C13.1887 16.9029 13.3613 16.3798 13.3613 15.6674C13.3613 14.9889 13.1775 14.5029 12.8101 14.2087C12.4425 13.9149 11.9082 13.7678 11.2073 13.7678H7.95077Z"
                    fill="white"
                />
                <path
                    d="M22.181 12.3096L24.0297 11.8008V21.8416C24.0297 22.0566 24.0407 22.2487 24.0635 22.4183C24.0861 22.5879 24.1145 22.7464 24.1483 22.8932C24.1935 23.0289 24.2443 23.1731 24.301 23.3257C24.3575 23.4784 24.4308 23.6339 24.5215 23.7922H22.571C22.5031 23.6792 22.4353 23.5266 22.3675 23.3342C22.322 23.1306 22.2882 22.9499 22.2657 22.7915C21.9265 23.1306 21.539 23.4164 21.1038 23.648C20.6684 23.8796 20.202 23.9957 19.7046 23.9957C19.1165 23.9957 18.5993 23.8995 18.1526 23.7073C17.7058 23.5152 17.3301 23.2494 17.0247 22.9103C16.7195 22.5711 16.4906 22.1669 16.3378 21.6975C16.1853 21.2285 16.1089 20.7222 16.1089 20.1795V19.3654C16.1089 17.9295 16.4876 16.8496 17.2453 16.1259C18.0027 15.4023 19.1052 15.0404 20.5526 15.0404C21.1065 15.0404 21.6492 15.1479 22.1809 15.3626L22.181 12.3096ZM22.181 17.0757C21.9321 16.9288 21.6467 16.8271 21.3244 16.7703C21.0022 16.7139 20.6995 16.6856 20.417 16.6856C19.9647 16.6856 19.583 16.7479 19.2722 16.8721C18.9611 16.9967 18.7067 17.1718 18.5089 17.3979C18.3109 17.6242 18.1698 17.8956 18.0848 18.212C18 18.5287 17.9576 18.8735 17.9576 19.2467V19.8742C17.9576 20.1909 17.9802 20.4991 18.0255 20.7986C18.0705 21.0983 18.1583 21.3612 18.2884 21.5872C18.4182 21.8136 18.5963 21.9972 18.8226 22.1384C19.0486 22.28 19.3425 22.3505 19.7046 22.3505C19.9421 22.3505 20.1765 22.3109 20.4085 22.2317C20.6401 22.1527 20.8636 22.0481 21.0785 21.918C21.2932 21.7881 21.494 21.6439 21.6805 21.4854C21.8671 21.3272 22.0339 21.1632 22.181 20.9936V17.0757Z"
                    fill="white"
                />
                <path
                    d="M26.387 14.294C26.387 13.9776 26.4294 13.6694 26.5143 13.3696C26.5991 13.0702 26.7319 12.8044 26.9128 12.5725C27.0936 12.3409 27.3311 12.1543 27.6251 12.0128C27.919 11.8716 28.2696 11.8008 28.6768 11.8008C28.8689 11.8008 29.0864 11.8206 29.3297 11.8602C29.5729 11.8999 29.7848 11.9479 29.9658 12.0044V13.463H29.2873C28.9367 13.463 28.6739 13.5591 28.4988 13.7513C28.3234 13.9437 28.2359 14.2093 28.2359 14.5485V15.2439H29.8811L29.3893 16.7703H28.2359V23.7922H26.3872V16.7703H25.3187V15.2439H26.3872V14.294H26.387Z"
                    fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_4569_9229">
                    <rect width="36" height="36" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}


const DownloadScorecard = () => {
    const location = useLocation()
    // const { item, htmlResponse } = location.state
    const [item, setItem] = useState<any>([])
    const [htmlResponse, setResponse] = useState<string>('')
    const htmlContentRef = useRef<HTMLDivElement>(null);


    useEffect(() => {
        const storedData = sessionStorage.getItem('viewScorecardData');
        if (storedData) {
            const { item, htmlResponse } = JSON.parse(storedData);
            // use item and htmlResponse here
            setItem(item)
            setResponse(htmlResponse)

        }
    }, []);
    const ShowCharts = () => {
        if (!htmlContentRef.current || !htmlResponse) return;

        const container = htmlContentRef.current;

        // Set HTML
        container.innerHTML = htmlResponse;

        // Execute scripts after DOM is ready
        setTimeout(() => {
            const scriptTags = container.querySelectorAll('script');

            scriptTags.forEach((oldScript) => {
                let scriptContent = oldScript.textContent || '';

                // Remove window.addEventListener('load') wrappers
                // Replace: window.addEventListener('load', () => {
                // With: (function() {
                scriptContent = scriptContent.replace(
                    /window\.addEventListener\s*\(\s*['"]load['"]\s*,\s*\(\s*\)\s*=>\s*\{/g,
                    '(function(){'
                );

                // Remove the closing }) of the addEventListener
                // Find the last occurrence of })
                const lastClosingBrace = scriptContent.lastIndexOf('})');
                if (lastClosingBrace !== -1 && scriptContent.includes('window.addEventListener')) {
                    scriptContent = scriptContent.substring(0, lastClosingBrace) + '})();' + scriptContent.substring(lastClosingBrace + 2);
                }

                // Execute the script
                try {
                    eval(scriptContent);
                    console.log('Script executed successfully');
                } catch (error) {
                    console.error('Script execution error:', error);
                }
            });
        }, 300);

    }
    // ShowCharts()
    useEffect(() => {
        ShowCharts()
    }, [htmlResponse]);

    const downloadScoreCard = async () => {
        ShowCharts()
        try {
            const data = `?clientEntityId=${storage.getItem('clientEntityId')}&venueId=${item.venueId}&allocationId=${item.allocationId}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}${storage?.getItem("idwc") === "true" ? `&isDownloadWithoutComments=true` : ""}`;
            const response = await ApiScoreCardPDF2(data);

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            link.download = `${item.venueName?.replaceAll(' ', '-')}-${Date.now()}.pdf`;
            document.body.appendChild(link);
            link.click();
            ShowCharts()
            link.remove();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            alert(error);
        }
    }

    const printScoreCard = async () => {
        ShowCharts()
        try {
            const data = `?clientEntityId=${storage.getItem('clientEntityId')}&venueId=${item.venueId}&allocationId=${item.allocationId}${storage.getItem('areaId') ? `&areaId=${storage.getItem('areaId')}` : ''}`;
            const response = await ApiScoreCardPDF2(data);

            const blob = new Blob([response.data], { type: 'application/pdf' });
            const url = window.URL.createObjectURL(blob);

            // Create hidden iframe to load PDF
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            iframe.src = url;
            document.body.appendChild(iframe);

            iframe.onload = () => {
                ShowCharts()
                iframe.contentWindow?.focus();
                iframe.contentWindow?.print();
                // cleanup after print
                setTimeout(() => {
                    document.body.removeChild(iframe);
                    window.URL.revokeObjectURL(url);
                }, 1000);
            };
        } catch (error) {
            alert(error);
        }
    };


    return (
        <Box height={'100%'} width={'100%'} className='m-0 p-0'>
            <Box className='d-flex w-100 align-items-center justify-content-between'>
                <IconButton onClick={() => { window.close() }}><CancelOutlined sx={{ fontSize: "36px" }} /></IconButton>
                <Box className='d-flex justify-content-end gap-2 w-100 my-2' sx={{ overflow: 'hidden' }}>
                    <Box onClick={() => { downloadScoreCard() }} className='btn-main border-10 d-flex flex-column p-2'>
                        <IconButton><CloudDownloadOutlinedIcon sx={{ fontSize: "36px", color: "#FFFFFF" }} /></IconButton>
                        <Typography>Download</Typography>
                    </Box>
                    <Box onClick={() => { printScoreCard() }} className='btn-main border-10  d-flex flex-column align-items-center p-2 px-3'>
                        <IconButton><PrintIcon sx={{ fontSize: "36px", color: "#FFFFFF" }} /></IconButton>
                        <Typography>Print</Typography>
                    </Box>
                </Box>
            </Box>
            <span
                ref={htmlContentRef}
                className="w-100 html-content"
                // style={{ width: "100%", height: "100vh" }}
                dangerouslySetInnerHTML={{ __html: htmlResponse }}
            />
        </Box>
    );
}

export default DownloadScorecard
